// Hero.jsx
import React from 'react';
import './Hero.css';

const Hero = () => {
  const scrollToAbout = (e) => {
    e.preventDefault();
    document.getElementById('about').scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="hero" className="hero section">
      {/* ✅ Use public/assets path (if image is in public) */}
      <img src={`${process.env.PUBLIC_URL}/assets/img/hero-bg1.jpg`} alt="" data-aos="fade-in" />

      <div className="container">
        <div className="row">
          <div
            className="col-lg-6 d-flex flex-column justify-content-center"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            <h2>ABCD International Family</h2>
            <p>
            Our Family isn’t just a training company—it’s a movement shaping the leaders 
            of tomorrow. With 11 World Records and a legacy of global impact, we inspire professionals 
            to go beyond limits and achieve extraordinary success.
            </p>
            <div className="d-flex mt-4">
              {/* ✅ Standardized class name */}
              <a href="#about" className="btn-get-started" onClick={scrollToAbout}>
                Get Started
              </a>
              <a
                href="https://www.youtube.com/watch?v=Y7f98aduVJ8"
                className="glightbox btn-watch-video d-flex align-items-center"
                aria-label="Watch intro video on YouTube"   
              >
                <i className="bi bi-play-circle"></i>
                <span>Watch Video</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
